import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { setLoading } from '../../redux/appSlice';
import './columnsPreferences.css';
import { updateUserTiles } from '../../services/dashboardservice';

const ColumnPreferencesModal = ({ userId, setShowModal, visibleColumns, setVisibleColumns, allColumns }) => {
  const dispatch = useDispatch();
  const [selectedColumns, setSelectedColumns] = useState([]);

  // Initialize with first 10 columns as default
  useEffect(() => {
    if (allColumns.length > 0) {
      const defaultColumns = allColumns.slice(0, 10).map(col => col.key);
      setSelectedColumns(visibleColumns.length > 0 ? visibleColumns : defaultColumns);
    }
  }, [allColumns, visibleColumns]);

  const handleColumnChange = (columnKey) => {
    setSelectedColumns((prev) =>
      prev.includes(columnKey) 
        ? prev.filter((key) => key !== columnKey) 
        : [...prev, columnKey]
    );
  };

  console.log(selectedColumns);

  const handleSave =  () => {
    try {
      dispatch(setLoading({ data: true }));
      
      //Save user preferences to backend
       updateUserTiles({
        userId,
        tileIds: selectedColumns,
        createdBy: userId
      });
      
      // Update visible columns in parent component
      setVisibleColumns(selectedColumns);
      setShowModal(false);
      dispatch(setLoading({ data: false }));
    } catch (err) {
      alert("Error saving column preferences: " + err.message);
      dispatch(setLoading({ data: false }));
    }
  };

  const handleResetToDefault = () => {
    const defaultColumns = allColumns.slice(0, 10).map(col => col.key);
    setSelectedColumns(defaultColumns);
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const modal = document.getElementById("columnPreferencesModal");
      if (event.target === modal) {
        setShowModal(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [setShowModal]);

  return (
    <div id="columnPreferencesModal" className="modal">
      <div className="modal-content-preferences">
        <div className="card shadow-sm p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Manage Report Columns</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={() => setShowModal(false)}
            ></button>
          </div>
          
          <div className="mb-3">
            <small className="text-muted">
              Select columns to display in the report. First 10 columns are shown by default.
            </small>
          </div>
          
          <div className="row" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {allColumns.map((column) => (
              <div key={column.key} className="col-md-6 mb-2">
                <div className="d-flex align-items-center">
                  <label className="small-switch me-2">
                    <input 
                      type="checkbox"
                      className="form-check-input"
                      checked={selectedColumns.includes(column.key)}
                      onChange={() => handleColumnChange(column.key)}
                    />
                    <span className="small-slider round"></span>
                  </label>
                  <label className="small-content-check mb-0">
                    {column.label}
                  </label>
                </div>
              </div>
            ))}
          </div>
            
          <div className="d-flex justify-content-between mt-4">
            <button 
              className="btn btn-outline-secondary preferences-btn" 
              onClick={handleResetToDefault}
            >
              Reset to Default
            </button>
            <div>
              <button 
                className="btn btn-secondary me-2 preferences-btn" 
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button 
                className="btn btn-primary preferences-btn" 
                onClick={handleSave}
              >
                Save Preferences
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Mock function - replace with your actual API call
const saveUserColumnPreferences = async (preferences) => {
  // Implement your API call here
  console.log('Saving preferences:', preferences);
  return Promise.resolve();
};

export default ColumnPreferencesModal;